import React, { useEffect, useState } from 'react'
import PageContainer from '../../Components/PageContainer'
import Feed from '../../Components/Feed'
import Select from 'react-select';
import Fade from 'react-reveal/Fade'
import cloudFunctions from '../../Helpers/cloudFunctions';
import { toast } from 'react-toastify';
import Spinner from '../../Components/Spinner';
import Search from '../../Components/Search';
import TagsCollection from '../../Components/PopularTags';
import { useNavigate } from 'react-router';
import { collection, getDocs, limit, orderBy, query, startAfter, where } from 'firebase/firestore';
import { firestore } from '../../firebase';
export default function Home() {
    const navigate = useNavigate()
    const options = [
        { value: 'trending', label: 'Trending' },
        { value: 'new', label: 'New' }
    ];
    const [header, setHeader] = useState("Trending Polls")
    const [selectedSort, setSelectedSort] = useState(options[0]);
    const [feedPosts, setFeedPosts] = useState(null)
    const [lastPost, setLastPost] = useState(null)
    const requestFeed = (startFresh) => {
        console.log("calling")
        const requestDocs = async (q) => {
            await getDocs(q).then(docs => {
                const newDocData = new Array()
                docs.forEach((dta) => newDocData.push({ ...dta.data(), id: dta.id }))
                if (feedPosts && !startFresh) {
                    setFeedPosts([...feedPosts, ...newDocData])
                } else {
                    setFeedPosts(newDocData)
                }
                if (docs.docs[docs.docs.length - 1] !== undefined) {
                    setLastPost(docs.docs[docs.docs.length - 1])
                }
            }).catch((err) => console.log(err))
        }
        if (lastPost && !startFresh) {
            requestDocs(query(collection(firestore, "polls"), orderBy(selectedSort.value === "new" ? "date" : "voters", "desc"), startAfter(lastPost), limit(25)))
        } else {
            requestDocs(query(collection(firestore, "polls"), orderBy(selectedSort.value === "new" ? "date" : "voters", "desc"), limit(25)))
        }
    }
    useEffect(() => {
        setHeader(selectedSort.label + " Polls")
        requestFeed(true)
    }, [selectedSort])
    const CurrentHeader = () => {
        return (
            <div>
                <div className="flex jcsb aic homeBarSortNav">
                    <Fade bottom duration={300} delay={500}>
                        <h1>{header}</h1>
                    </Fade>
                    <div style={{ width: 200, fontWeight: 600 }}>
                        <Select
                            defaultValue={selectedSort}
                            onChange={setSelectedSort}
                            options={options}
                        />
                    </div>
                </div>
            </div>
        )
    }
    return (
        <PageContainer>
            <div style={{ height: 1500 }}>
                <div className='mobileSearchHeader'>
                    <Search />
                    <TagsCollection tags={["Gaming", "PRO"]} />
                </div>
                <div className='homeHeaderCurrent' style={{ marginTop: 25, marginBottom: 17, zIndex: 2000 }}>
                    <CurrentHeader />
                </div>
                {feedPosts
                    ? <Feed requestFeed={() => requestFeed(false)} posts={feedPosts} />
                    : <Spinner style={{ borderTop: "3px solid rgba(0, 0, 0, .1)" }} />
                }
            </div>
            <button className='mobileCreateBtn flex aic jcc b1' onClick={() => navigate("/create")}>
                <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" width="30px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" /></svg>
            </button>
        </PageContainer>
    )
}
